import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {Router} from '@angular/router';
import {AuthRequest} from '../../../dtos/auth-request';
import {MatDialog} from '@angular/material/dialog';
import {RegistrationComponent} from '../registration/registration.component';
import {ResetPasswordComponent} from '../reset-password/reset-password.component';
import {NotificationService} from '../../../services/common/notification.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  hide: boolean;
  loginForm: UntypedFormGroup;
  submitted = false;
  register: boolean;
  loginInvalid: boolean;

  constructor(private formBuilder: UntypedFormBuilder, private authService: AuthService, private resetPassword: MatDialog,
              private router: Router, private matDialog: MatDialog, private notificationService: NotificationService) {
    this.hide = true;
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
    this.register = this.router.getCurrentNavigation()?.extras.state?.register;
  }

  ngOnInit(): void {
    if (this.register) {
      this.openRegistrationDialog();
    }
  }

  /**
   * Form validation will start after the method is called, additionally an AuthRequest will be sent
   */
  loginUser() {
    this.submitted = true;
    if (this.loginForm.valid) {
      const authRequest: AuthRequest = new AuthRequest(this.loginForm.controls.username.value.trim(),
        this.loginForm.controls.password.value);
      this.authenticateUser(authRequest);
    }
    this.loginForm.markAllAsTouched();
  }

  /**
   * Send authentication data to the authService. If the authentication was successfully, the user will be forwarded to the message page
   *
   * @param authRequest authentication data from the user login form
   */
  authenticateUser(authRequest: AuthRequest) {
    this.authService.loginUser(authRequest).subscribe(
      () => {
        this.loginInvalid = false;
        this.router.navigate(['/']);
      }, error => {
        if (error.url.includes('authentication')) {
          this.loginInvalid = true;
        } else {
          this.notificationService.openSnackBar(error);
        }
      }
    );
  }

  openRegistrationDialog() {
    this.matDialog.open(RegistrationComponent);
  }

  openResetPasswordDialog() {
    this.resetPassword.open(ResetPasswordComponent);
  }
}
